import React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";

interface RadioButtonProps {
  selected: boolean;
  onPress: () => void;
  size?: number;
  color?: string;
  selectedColor?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  selected,
  onPress,
  size = 24,
  color = "#FF9800", // default orange border
  selectedColor = "#2E1A73", // default dark fill
}) => {
  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
      <View
        style={[
          styles.outerCircle,
          {
            width: size,
            height: size,
            borderColor: color,
            borderRadius: size / 2,
          },
        ]}
      >
        {selected ? (
          <View
            style={[
              styles.innerCircle,
              {
                width: size * 0.9,
                height: size * 0.9,
                backgroundColor: selectedColor,
                borderRadius: (size * 0.9) / 2,
              },
            ]}
          />
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  outerCircle: {
    borderWidth: 2,
    justifyContent: "center",
    alignItems: "center",
  },
  innerCircle: {},
});

export default RadioButton;
